// import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
// import { getAllCampaigns } from '../components/api2';
// import Card from '../pages/card';
// import "./style.css";

// const ITEMS_PER_PAGE = 10;
// const PAGES_DISPLAYED = 5;

// const LiveCustomer = () => {
//     const location = useLocation();
//     const [campaigns, setCampaigns] = useState([]);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [filter, setFilter] = useState('all');
//     const [filteredCampaigns, setFilteredCampaigns] = useState([]);

//     useEffect(() => {
//         const fetchCampaigns = async () => {
//             try {
//                 const allCampaigns = await getAllCampaigns();
//                 console.log('API response:', allCampaigns); // Debugging log to check API response

//                 // Remove filtering by 'approve' field
//                 setCampaigns(allCampaigns);
//                 setFilteredCampaigns(allCampaigns);
//             } catch (error) {
//                 console.error('Error fetching campaigns:', error);
//             }
//         };

//         fetchCampaigns();
//     }, [location]); // Add location dependency if route change affects fetching
//     useEffect(() => {
//         // Apply filtering logic based on selected filter
//         if (filter === 'all') {
//             setFilteredCampaigns(campaigns);
//         } else if (filter === 'appliedUsers') {
//             const appliedCampaigns = campaigns.filter((campaign) => campaign.appliedUsers === true); // Adjust filtering condition
//             setFilteredCampaigns(appliedCampaigns);
//         }
//     }, [filter, campaigns]);
//     const totalPages = Math.ceil(filteredCampaigns.length / ITEMS_PER_PAGE);
//     const startPage = Math.max(1, Math.min(currentPage - Math.floor(PAGES_DISPLAYED / 2), totalPages - PAGES_DISPLAYED + 1));
//     const endPage = Math.min(totalPages, startPage + PAGES_DISPLAYED - 1);
//     const paginatedCampaigns = filteredCampaigns.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);

//     const handlePageChange = (page) => {
//         setCurrentPage(page);
//     };

//     return (
//         <div className='container1'>
//             {/* <div className="buttons is-right">
//                 <button
//                     className={`button ${filter === 'applied' ? 'is-primary' : ''}`}
//                     onClick={() => setFilter('applied')}
//                 >
//                     My Applied Campaigns
//                 </button>
//                 <button
//                     className={`button ${filter === 'all' ? 'is-primary' : ''}`}
//                     onClick={() => setFilter('all')}
//                 >
//                     All Campaigns
//                 </button>
//             </div> */}
//             <h1 className='title is-1 has-text-centered'><b>Brand Collabs For You</b></h1>
//             <h2 className='subtitle is-3 has-text-centered mt-3'>BROUGHT TO YOU WITH LOVE FROM HOBO.VIDEO</h2>
//             <div className="button is-centered">
//                 <div className="tabs is-centered">
//                     <ul style={{ display: 'flex', gap: '10px' }}> {/* Add spacing between buttons */}
//                         <li className={`is-active`}>
//                             <button
//                                 className={`button ${filter === 'applied' ? 'is-primary' : ''}`}
//                                 onClick={() => setFilter('applied')}
//                                 style={{ borderRadius: '5px', padding: '7px' }}
//                             >
//                                 <span> My Applied Campaigns</span>
//                             </button>
//                         </li>
//                         <li>
//                             <button
//                                 className={`button ${filter === 'all' ? 'is-primary' : ''}`}
//                                 onClick={() => setFilter('all')}
//                                 style={{ borderRadius: '5px', padding: '7px' }}
//                             >
//                                 <span> All Campaigns</span>
//                             </button>
//                         </li>
//                     </ul>
//                 </div>

//             </div>
//             <div className="columns is-multiline is-centered">
//                 {paginatedCampaigns.length > 0 ? (
//                     paginatedCampaigns.map((campaign, index) => (
//                         <div key={index} className="column is-half">
//                             <Card campaign={campaign} alignLeft={index % 2 === 0} />
//                         </div>
//                     ))
//                 ) : (
//                     <div>No campaigns to display</div>
//                 )}
//             </div>
//             <div className="pagination is-centered" role="navigation" aria-label="pagination">
//                 {currentPage > 1 && (
//                     <button className="pagination-previous" onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
//                 )}
//                 {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map((page) => (
//                     <button key={page} className={`pagination-link ${page === currentPage ? 'is-current' : ''}`} aria-label={`Goto page ${page}`} onClick={() => handlePageChange(page)}>
//                         {page}
//                     </button>
//                 ))}
//                 {currentPage < totalPages && (
//                     <button className="pagination-next" onClick={() => handlePageChange(currentPage + 1)}>Next</button>
//                 )}
//             </div>
//         </div >
//     );
// };

// export default LiveCustomer;

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { getAllCampaigns } from '../components/api2';
import Card from '../pages/card';
import { Config } from '../.env.js';
import './style.css';
import Header from './Header';
import Footer from './Footer';

const ITEMS_PER_PAGE = 10;
const PAGES_DISPLAYED = 5;

const LiveCustomer = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [campaigns, setCampaigns] = useState([]);
    const [currentPage, setCurrentPage] = useState(() => {
        const savedPage = localStorage.getItem('liveCustomerPage');
        return savedPage ? parseInt(savedPage, 10) : 1;
    });
    const [filter, setFilter] = useState('all');
    const [filteredCampaigns, setFilteredCampaigns] = useState([]);
    const [userId, setUserId] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchCampaigns = async () => {
            setLoading(true);
            try {
                const loggedInId = localStorage.getItem("loggedInUserId");
                setUserId(loggedInId);

                const allCampaigns = await getAllCampaigns();
                allCampaigns.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

                const today = new Date().toISOString().split("T")[0];

                // 👉 Parallel fetching of product data for all campaigns
                const campaignProductPromises = allCampaigns.map(async (campaign) => {
                    const campaignName = campaign.campaignName;

                    try {
                        const { data: productData } = await axios.get(
                            `${Config.API_URL}/api/product?campaignName=${encodeURIComponent(campaignName)}`
                        );

                        const product = Array.isArray(productData) ? productData[0] : productData;

                        if (product && product.date) {
                            const campaignDate = new Date(product.date).toISOString().split("T")[0];
                            if (campaignDate <= today) {
                                return campaign;
                            }
                        }
                    } catch (error) {
                        console.warn(`⚠️ No product found for campaign: ${campaignName}`);
                    }

                    return null;
                });

                const resolvedCampaigns = await Promise.all(campaignProductPromises);
                const filteredLiveCampaigns = resolvedCampaigns.filter(Boolean);

                setCampaigns(filteredLiveCampaigns);
                setFilteredCampaigns(filteredLiveCampaigns);
            } catch (error) {
                console.error("❌ Error fetching campaigns:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchCampaigns();
    }, [location]);

    useEffect(() => {
        if (filter === 'all') {
            setFilteredCampaigns(campaigns);
        } else if (filter === 'applied') {
            const appliedCampaigns = (campaigns || []).filter((campaign) => {
                if (!campaign || !Array.isArray(campaign.appliedUsers)) return false;
                return campaign.appliedUsers.includes(userId);
            });
            setFilteredCampaigns(appliedCampaigns);
        }
    }, [filter, campaigns, userId]);

    useEffect(() => {
        localStorage.setItem('liveCustomerPage', currentPage.toString());
    }, [currentPage]);

    const totalPages = Math.ceil(filteredCampaigns.length / ITEMS_PER_PAGE);
    const startPage = Math.max(1, Math.min(currentPage - Math.floor(PAGES_DISPLAYED / 2), totalPages - PAGES_DISPLAYED + 1));
    const endPage = Math.min(totalPages, startPage + PAGES_DISPLAYED - 1);
    const paginatedCampaigns = filteredCampaigns.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (
        <>
            <Header />
            <div className='container1' style={{ position: 'relative' }}>
                <h1 className='title is-1 has-text-centered' style={{ marginTop: "100px" }}><b>Brand Collabs For You</b></h1>
                <h2 className='subtitle is-3 has-text-centered mt-3'>BROUGHT TO YOU WITH LOVE FROM HOBO.VIDEO</h2>

                <div className="button is-centered">
                    <div className="tabs is-centered">
                        <ul style={{ display: 'flex', gap: '10px' }}>
                            <li className={`is-active`}>
                                <button
                                    className={`button ${filter === 'applied' ? 'is-primary' : ''}`}
                                    onClick={() => setFilter('applied')}
                                    style={{ borderRadius: '5px', padding: '7px' }}
                                >
                                    <span> My Applied Campaigns</span>
                                </button>
                            </li>
                            <li>
                                <button
                                    className={`button ${filter === 'all' ? 'is-primary' : ''}`}
                                    onClick={() => setFilter('all')}
                                    style={{ borderRadius: '5px', padding: '7px' }}
                                >
                                    <span> All Campaigns</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>

                {loading ? (
                    <div className="has-text-centered" style={{ margin: '100px 0' }}>
                        <span className="loader"></span>
                        <p>Loading campaigns...</p>
                    </div>
                ) : (
                    <div className="columns is-multiline is-centered">
                        {paginatedCampaigns.length > 0 ? (
                            paginatedCampaigns.map((campaign, index) => (
                                <div
                                    key={campaign._id || index}
                                    className={`column ${paginatedCampaigns.length === 1 ? 'is-full' : 'is-half'}`}
                                >
                                    <Card campaign={campaign} alignLeft={index % 2 === 0} />
                                </div>
                            ))
                        ) : (
                            <div className="has-text-centered">No campaigns to display</div>
                        )}
                    </div>
                )}

                <div className="pagination is-centered" role="navigation" aria-label="pagination">
                    {currentPage > 1 && (
                        <button className="pagination-previous" onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
                    )}
                    {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map((page) => (
                        <button key={page} className={`pagination-link ${page === currentPage ? 'is-current' : ''}`} aria-label={`Goto page ${page}`} onClick={() => handlePageChange(page)}>
                            {page}
                        </button>
                    ))}
                    {currentPage < totalPages && (
                        <button className="pagination-next" onClick={() => handlePageChange(currentPage + 1)}>Next</button>
                    )}
                </div>
            </div>
            <Footer />
        </>
    );
};

export default LiveCustomer;
